
import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    IconButton, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon, CheckCircle as ActivateIcon, Search as SearchIcon, Info as Info } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData, postData, updateData } from '../../../apiService'; // Ensure postData is defined
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import ReactDOM from 'react-dom';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import { Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select'; // Import react-select

function DriverBataIndex() {
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, token, logout, userId } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const branchId = 0;
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [fileData, setFileData] = useState([]);


    useEffect(() => {

        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
    }, [isAuthenticated, companyId, branchId, token, logout]);


    useEffect(() => {
        const shouldReload = localStorage.getItem('shouldReload') === 'true';

        // Only reload data if navigated from PurchaseOrderCreate and flag is set
        if (location.state?.from === '/SaleCreate' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else if (location.state?.from === '/SaleEdit' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }

        else if (location.state?.from === '/SaleDetails' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else {
            // Populate data without reloading for other cases
            setFromDate(getFormattedStartDate());
            setToDate(getFormattedCurrentDate());
            // handleClickOpen(false);
        }
    }, [location]);

    const fetchtableData = async () => {
        setData([]);
        try {
            const response = await fetchData('DriversBataApi', `/AttendanceDetails/${companyId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const searchableFields = ['BillPrefix', 'FinYear', 'BillNumber', 'BillDate', 'CustomerName', 'TotalQuantity', 'TaxableAmount', 'CGSTAmount', 'SGSTAmount', 'IGSTAmount', 'GrandTotal', 'TotalQuantity'];

    const filteredData = data.filter((item) =>
        searchableFields.some((key) =>
            item[key]?.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
    );





    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const openImportDialog = () => {
        setImportDialogOpen(true);
    };

    const closeImportDialog = () => {
        setImportDialogOpen(false);
        setFileData([]);
    };

    const [selectedMonthYear, setSelectedMonthYear] = useState(() => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0"); // ensures 01–12
        return `${year}-${month}`; // example: "2025-10"
    });


    // ✅ handle month-year picker change
    const handleMonthYearChange = (e) => {
        setSelectedMonthYear(e.target.value);
    };

    // ✅ handle Excel file
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file || !selectedMonthYear) {
            alert("Please select a month and year before uploading the file.");
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const rowsToRead = sheetData.slice(2); // skip first 2 rows

            // ✅ Convert selected month-year to date
            const [year, month] = selectedMonthYear.split("-");
            const bataDate = new Date(year, month - 1, 1); // 1st day of the selected month

            // Format month name and year for table view
            const monthName = bataDate.toLocaleString("default", { month: "long" });
            const displayYear = bataDate.getFullYear();

            const formattedData = rowsToRead
                .filter(row => row[1] && row[2]) // Ensure Employee Code & Name exist
                .map((row) => ({
                    EmployeeCode: row[1] ? String(row[1]) : "",
                    EmployeeName: row[2] ? String(row[2]) : "",
                    PeelingBata: row[3] ? parseFloat(row[3]) : 0,
                    ExtraHoursBata: row[4] ? parseFloat(row[4]) : 0,
                    TankerBata: row[5] ? parseFloat(row[5]) : 0,
                    TotalBata: row[6] ? parseFloat(row[6]) : 0,
                    IsActive: true,
                    BataDate: bataDate.toISOString(), // store full date (1st of month)
                    MonthName: monthName, // for display
                    Year: displayYear, // for display
                    CompanyId: companyId,
                }));

            setFileData(formattedData);
        };

        reader.readAsArrayBuffer(file);
    };


    const BATCH_SIZE = 500; // adjust as needed

    const handleImport = async () => {
        try {
            setIsLoading(true);

            const totalBatches = Math.ceil(fileData.length / BATCH_SIZE);


            const [year, month] = selectedMonthYear.split("-");
            const bataDate = `${year}-${month}-01`; // ✅ plain date string


            for (let i = 0; i < totalBatches; i++) {
                const batch = fileData.slice(i * BATCH_SIZE, (i + 1) * BATCH_SIZE);

                const CreateData = {
                    CompanyId: companyId,
                    CreatedBy: userId,
                    BataImportDate: bataDate,
                    DriversBataImport: batch
                };

                await postData('DriversBataApi', CreateData, token);
                console.log(`Batch ${i + 1} uploaded`);
            }

            setFileData([]);
            closeImportDialog();
            setIsLoading(false);

            setTimeout(() => window.location.reload(), 500);
        } catch (error) {
            console.error('Error posting data:', error);
            setIsLoading(false);
        }
    };


    const cellStyle = {
        padding: '4px 8px',
        border: '1px solid #ccc',
        fontSize: '11px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
    };


    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [selectedAttendance, setSelectedAttendance] = useState(null);
    const handleOpenEditModal = (attendanceItem) => {
        setSelectedAttendance(attendanceItem);
        setEditDialogOpen(true);
    };

    const handleCloseEditModal = () => {
        setEditDialogOpen(false);
        setSelectedAttendance(null);
    };




    return (
        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '-10px' }}>

            <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Drivers Bata </h6>



                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber" style={{ fontSize: '11px' }}>
                        From
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber" style={{ fontSize: '11px' }}>
                        To
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <Button
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '20px',
                        padding: '5px 10px',
                        border: '1px solid blue',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        marginLeft: '15px',
                        marginTop: '1.50%',
                        textTransform: 'uppercase'
                    }}
                    onClick={fetchtableData}
                    className="linkcolor"
                >
                    <Tooltip title="Get Bata Details" arrow>
                        Refresh
                    </Tooltip>
                </Button>

                {hasCreateMasterPermission && (
                    <Button

                        onClick={openImportDialog}
                        className="linkcolor"
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '20px',
                            padding: '5px 10px',
                            border: '1px solid black',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                            marginTop: '1.50%',
                            textTransform: 'uppercase'

                        }}
                    >
                        <Tooltip title="Create New Sale" arrow>
                            IMPORT
                        </Tooltip>

                    </Button>
                )}
            </div>

            <div className="w-full mb-6 rounded-2xl border border-gray-100 shadow-sm overflow-hidden bg-white">
                <TableContainer
                    component={Paper}
                    sx={{
                        maxHeight: 580,
                        overflowY: "auto",
                        border: "none",
                        boxShadow: "none",
                        backgroundColor: "#fff",
                    }}
                >
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                {[
                                    "Sl.No",
                                    "Employee ID",
                                    "Employee Name",
                                    "Month",
                                    "BATA (DAY/NIGHT/PEELING)",
                                    "EXTRA HOURS BATA",
                                    "WATER TANKER BATA",
                                    "TOTAL BATA",
                                    "",
                                ].map((title, idx) => {
                                    // ✅ Columns that should be right-aligned
                                    const rightAlignedColumns = [4, 5, 6, 7];
                                    const align = rightAlignedColumns.includes(idx) ? "right" : "left";

                                    return (
                                        <TableCell
                                            key={idx}
                                            sx={{
                                                background: 'linear-gradient(to right, #103641, #144350)',
                                                color: "#f2f5f9ff",
                                                fontWeight: 600,
                                                fontSize: "12px",
                                                borderBottom: "2px solid #e2e8f0",
                                                textAlign: align,
                                                whiteSpace: "nowrap",
                                                textTransform: "uppercase",
                                                padding: "4px 3px",
                                                letterSpacing: "0.3px",
                                            }}
                                        >
                                            {title}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>


                        <TableBody>
                            {data.map((item, index) => (
                                <TableRow
                                    key={item.Id}
                                    sx={{
                                        "&:hover": {
                                            backgroundColor: "#f9fafb", // light hover like Zoho
                                        },
                                        transition: "background-color 0.2s ease-in-out",
                                        borderBottom: "1px solid #f1f5f9",
                                    }}
                                >

                                    <TableCell sx={{ fontSize: "13px", padding: "6px", color: "#0f172a", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Tooltip title="Edit Bata" arrow>
                                            <IconButton
                                                color="primary"
                                                size="small"
                                                onClick={() => handleOpenEditModal(item)}
                                            >
                                                <EditIcon style={{ fontSize: '12px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        <span style={{ marginRight: 8 }}>{index + 1}</span>
                                    </TableCell>
                                    <TableCell sx={{ fontSize: "13px", padding: "6px", color: "#0f172a" }}>
                                        {item.EmployeeCode}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: "13px", padding: "6px", color: "#0f172a", fontWeight: 500 }}>
                                        {item.EmployeeName}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: "13px", padding: "6px", color: "#0f172a" }}>
                                        {item.BataDate
                                            ? new Date(item.BataDate).toLocaleString("en-US", {
                                                month: "long",
                                                year: "numeric",
                                            })
                                            : ""}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontSize: "13px",
                                            padding: "6px",
                                            textAlign: "right",
                                            color: "#0f172a",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {item.PeelingBata}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontSize: "13px",
                                            padding: "6px",
                                            textAlign: "right",
                                            color: "#0f172a",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {item.ExtraHoursBata}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontSize: "13px",
                                            padding: "6px",
                                            textAlign: "right",
                                            color: "#0f172a",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {item.TankerBata}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontSize: "13px",
                                            padding: "6px",
                                            textAlign: "right",
                                            color: "#0f172a",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {item.TotalBata}
                                    </TableCell>
                                    <TableCell align="right" sx={{ padding: "6px" }}>
                                        {/* Add actions (Edit/Delete) here later */}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>


            {/* Import Dialog */}
            <Dialog
                open={importDialogOpen}
                onClose={closeImportDialog}
                aria-labelledby="import-dialog-title"
                aria-describedby="import-dialog-description"
                maxWidth="lg"
                fullWidth
            >
                {/* <DialogTitle id="import-dialog-title">Import Drivers Bata</DialogTitle> */}
                <DialogTitle
                    id="import-dialog-title"
                    sx={{ display: "flex", alignItems: "center", gap: 2 }}
                >
                    Import Drivers Bata
                    {/* ✅ Month-Year Picker */}
                    <TextField
                        type="month"
                        size="small"
                        value={selectedMonthYear}
                        onChange={handleMonthYearChange}
                        sx={{ ml: 2, minWidth: 180, height: 35, fontSize: '12px' }}
                    />
                </DialogTitle>

                <DialogContent>
                    <DialogContentText id="import-dialog-description">
                        Select an Excel file to import Bata data. The data will be previewed before importing.
                    </DialogContentText>
                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                        style={{ marginTop: '16px' }}
                    />
                    <TableContainer component={Paper} sx={{ mt: 2, border: '1px solid #ccc' }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {[
                                        "Month", "Employee Code", "Employee Name", "BATA (DAY/NIGHT/PEELING)", "EXTRA HOURS BATA", "WATER TANKER BATA", "TOTAL BATA"
                                    ].map((header, i) => (
                                        <TableCell
                                            key={i}
                                            sx={{
                                                padding: '4px 8px',
                                                border: '1px solid #ccc',
                                                backgroundColor: '#d9e1f2', // light Excel blue
                                                fontWeight: 'bold',
                                                fontSize: '13px',
                                                textAlign: 'center',
                                                whiteSpace: 'nowrap',
                                                textTransform: 'uppercase',
                                            }}
                                        >
                                            {header}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fileData.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell sx={{ ...cellStyle, textAlign: "center" }}>
                                            {row.MonthName} - {row.Year}
                                        </TableCell>
                                        <TableCell sx={{ ...cellStyle }}>{row.EmployeeCode}</TableCell>
                                        <TableCell sx={{ ...cellStyle }}>{row.EmployeeName}</TableCell>
                                        <TableCell sx={{ ...cellStyle, textAlign: "right" }}>{row.PeelingBata}</TableCell>
                                        <TableCell sx={{ ...cellStyle, textAlign: "right" }}>{row.ExtraHoursBata}</TableCell>
                                        <TableCell sx={{ ...cellStyle, textAlign: "right" }}>{row.TankerBata}</TableCell>
                                        <TableCell sx={{ ...cellStyle, textAlign: "right" }}>{row.TotalBata}</TableCell>
                                    </TableRow>
                                ))}

                                {/* ✅ Total Row */}
                                <TableRow
                                    sx={{
                                        backgroundColor: "#f3f3f3",
                                        fontWeight: "bold",
                                    }}
                                >
                                    <TableCell
                                        colSpan={3}
                                        sx={{ ...cellStyle, textAlign: "right", fontWeight: "bold" }}
                                    >
                                        TOTAL:
                                    </TableCell>
                                    <TableCell sx={{ ...cellStyle, textAlign: "right", fontWeight: "bold" }}>
                                        {fileData.reduce((sum, r) => sum + (parseFloat(r.PeelingBata) || 0), 0).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ ...cellStyle, textAlign: "right", fontWeight: "bold" }}>
                                        {fileData.reduce((sum, r) => sum + (parseFloat(r.ExtraHoursBata) || 0), 0).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ ...cellStyle, textAlign: "right", fontWeight: "bold" }}>
                                        {fileData.reduce((sum, r) => sum + (parseFloat(r.TankerBata) || 0), 0).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ ...cellStyle, textAlign: "right", fontWeight: "bold" }}>
                                        {fileData.reduce((sum, r) => sum + (parseFloat(r.TotalBata) || 0), 0).toFixed(2)}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={closeImportDialog} color="primary">Cancel
                    </Button>

                    <Button variant="contained" onClick={handleImport} color="secondary" disabled={isLoading || fileData.length === 0}>
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "Import"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit Attendance Dialog */}
            <Dialog
                open={editDialogOpen}
                onClose={handleCloseEditModal}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    className: "rounded-xl border border-gray-200 shadow-lg bg-white font-inter",
                }}
            >

                {/* Header */}
                <div
                    className="text-center py-1"
                    style={{
                        backgroundColor: "#0d4f5f", // deep blue header
                        color: "#ffffff",
                        fontWeight: "bold",
                        fontSize: "14px",
                        letterSpacing: "0.5px",
                        marginTop: "-1px",
                        textTransform: "uppercase",
                    }}
                >
                    Edit Driver Bata
                </div>

                {selectedAttendance && (
                    <div className="p-4">
                        <h6 style={{ fontSize: '12.5px',color:'darkblue',fontWeight:'bold' }}>{(`${selectedAttendance.EmployeeCode} - ${selectedAttendance.EmployeeName}`)}</h6>
                        <div className="bg-white border border-gray-200 rounded-lg p-4">
                            {/* Bata Fields in a single row */}
                            <div className="grid grid-cols-4 gap-4">
                                {[
                                    { label: "Bata (Day/Night/Peeling)", key: "PeelingBata" },
                                    { label: "Extra Hours Bata", key: "ExtraHoursBata" },
                                    { label: "Water Tanker Bata", key: "TankerBata" },
                                ].map((field) => (
                                    <div key={field.key} className="flex flex-col">
                                        <label className="text-sm uppercase text-gray-700 mb-1" style={{ fontSize: '11.5px', fontWeight: 'bold' }}>
                                            {field.label}
                                        </label>
                                        <input
                                            type="number"
                                            value={selectedAttendance[field.key] || 0}
                                            onChange={(e) => {
                                                const value = Number(e.target.value);
                                                const updatedAttendance = {
                                                    ...selectedAttendance,
                                                    [field.key]: value,
                                                };
                                                // Update TotalBata automatically
                                                updatedAttendance.TotalBata =
                                                    (updatedAttendance.PeelingBata || 0) +
                                                    (updatedAttendance.ExtraHoursBata || 0) +
                                                    (updatedAttendance.TankerBata || 0);
                                                setSelectedAttendance(updatedAttendance);
                                            }}
                                            className="border border-gray-300 rounded px-3 py-2 text-base text-gray-900 placeholder-gray-400 focus:outline-none focus:border-[#13315c] h-8"
                                            style={{ textAlign: "right" }}
                                        />
                                    </div>
                                ))}

                                {/* TotalBata Field */}
                                <div className="flex flex-col">
                                    <label className="text-sm uppercase text-gray-700 mb-1" style={{ fontSize: '11.5px', fontWeight: 'bold' }}>
                                        Total Bata
                                    </label>
                                    <input
                                        type="number"
                                        value={selectedAttendance.TotalBata || 0}
                                        readOnly
                                        className="border border-gray-300 rounded px-3 py-2 text-base text-gray-900 placeholder-gray-400 bg-gray-100 h-8"
                                        style={{ textAlign: "right" }}
                                    />
                                </div>
                            </div>


                            {/* Action Buttons */}
                            <div className="flex justify-end gap-2 pt-4">
                                <button
                                    className="px-4 py-1 text-sm font-semibold rounded bg-[#0d4f5f] text-white hover:bg-[#0b3f4c] transition-colors"
                                    style={{
                                        backgroundColor: "#0d4f5f", // deep blue
                                        color: "#ffffff",
                                        border: "1px solid #0d4f5f",
                                        height: "31px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    onClick={async () => {
                                        try {
                                            const updatePayload = {
                                                ...selectedAttendance,
                                                UpdatedBy: userId,
                                                CompanyId: companyId,
                                            };
                                            console.log("Final Payload", updatePayload);
                                            await updateData("DriversBataApi", userId, updatePayload, token);
                                            fetchtableData();
                                            handleCloseEditModal();
                                        } catch (err) {
                                            console.error("Update error:", err);
                                            alert("Error updating attendance");
                                        }
                                    }}
                                >
                                    Update
                                </button>

                                <button
                                    className="px-4 py-1 text-sm font-semibold rounded border border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition-colors"
                                    style={{
                                        backgroundColor: "#ffffff",
                                        color: "#d3240d",
                                        border: "1px solid #d3240d",
                                        height: "31px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    onClick={handleCloseEditModal}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </Dialog>


        </div >
    );
}

export default DriverBataIndex;



